import { Action } from "redux";

import { API_STAGES } from "@redux/create-api-module";
import { $ApiModuleName } from "@redux/store.types";

import { TApiLoadingState } from "./loading.types";

const LoadingReducer = (
    state: TApiLoadingState = {},
    action: Action<string>,
) => {
    const { type } = action;
    const matches = /(.*)\/(.*)\/(pending|success|failure|reset)/.exec(type);

    if (!matches) return state;

    const [, prefix, requestName, requestState] = matches;
    if (prefix !== $ApiModuleName) {
        return state;
    }

    return {
        ...state,
        [requestName]: requestState === API_STAGES.Pending.toLowerCase(),
    };
};

export default LoadingReducer;
